/* Linsoul footer: mobile disclosure, country selector, back to top, AJAX newsletter. */
(function () {
  'use strict';
  const mq = matchMedia('(max-width:640px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let teardown = null;

  function init() {
    teardown?.();
    const footer = document.querySelector('[data-lhf-footer]');
    if (!footer) return;
    const ac = new AbortController();
    const signal = ac.signal;
    const toggles = () => Array.from(footer.querySelectorAll('.lhf-footer-toggle'));
    const listFor = (b) => document.getElementById(b.getAttribute('aria-controls'));

    function sync() {
      toggles().forEach((b) => {
        const list = listFor(b);
        if (!list) return;
        b.disabled = !mq.matches;
        b.setAttribute('aria-expanded', String(!mq.matches));
        list.hidden = mq.matches;
        list.inert = mq.matches;
      });
    }
    sync();
    mq.addEventListener('change', sync, { signal });

    footer.addEventListener('click', (e) => {
      const toggle = e.target.closest('.lhf-footer-toggle');
      if (toggle && mq.matches) {
        const list = listFor(toggle);
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        list.hidden = open;
        list.inert = open;
        return;
      }
      if (e.target.closest('.lhf-back-top')) {
        window.scrollTo({ top: 0, behavior: reduced.matches ? 'instant' : 'smooth' });
        document.querySelector('.ml-logo, a[href="/"]')?.focus({ preventScroll: true });
      }
    }, { signal });

    const newsletter = footer.querySelector('[data-lhf-newsletter]');
    if (newsletter) bindNewsletter(newsletter, signal);

    teardown = () => ac.abort();
  }

  /* Shopify's hCaptcha provider binds to customer forms on first focus: it saves the
     form's submit() and calls it after appending the h-captcha-response token. Making
     submit() the AJAX sender (before the provider binds) lets the token ride along. */
  const CAPTCHA_BOUND = 'data-hcaptcha-bound';

  function bindNewsletter(form, signal) {
    if (!form.dataset.lhfAjax) {
      form.dataset.lhfAjax = 'true';
      const nativeSubmit = HTMLFormElement.prototype.submit.bind(form);
      form.submit = () => send(form, nativeSubmit);
    }
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (form.dataset.busy === 'true' || !form.reportValidity()) return;
      const { show } = ui(form);
      show('sending');
      clearTimeout(form._lhfStall);
      form._lhfStall = setTimeout(() => show('error'), 15000);
      if (form.hasAttribute(CAPTCHA_BOUND)) return;
      captchaReady(form).then(() => form.submit());
    }, { signal });
  }

  function captchaReady(form) {
    if (!window.Shopify?.captcha) return Promise.resolve();
    return new Promise((resolve) => {
      const start = Date.now();
      (function poll() {
        if (form.hasAttribute(CAPTCHA_BOUND) || Date.now() - start > 4000) resolve();
        else setTimeout(poll, 100);
      })();
    });
  }

  function ui(form) {
    const status = form.querySelector('[data-lhf-newsletter-status]');
    const email = form.querySelector('input[type="email"]');
    const msg = {
      sending: form.dataset.msgSending || 'Subscribing…',
      success: form.dataset.msgSuccess || 'Thanks for subscribing.',
      error: form.dataset.msgError || 'Something went wrong. Please try again.'
    };
    return {
      email,
      show(state, text) {
        status.dataset.state = state;
        status.textContent = text || msg[state];
        const invalid = state === 'error';
        email.toggleAttribute('aria-invalid', invalid);
        if (invalid) email.setAttribute('aria-describedby', status.id);
        else email.removeAttribute('aria-describedby');
      }
    };
  }

  async function send(form, nativeSubmit) {
    if (form.dataset.busy === 'true') return;
    clearTimeout(form._lhfStall);
    const { show, email } = ui(form);
    const button = form.querySelector('button[type="submit"]');
    form.dataset.busy = 'true';
    button.disabled = true;
    show('sending');
    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      });
      if (/\/challenge\b/.test(res.url)) {
        nativeSubmit();
        return;
      }
      if (/[?&]customer_posted=true/.test(res.url)) {
        show('success');
        form.reset();
        return;
      }
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const returned = doc.querySelector('[data-lhf-newsletter-status]');
      const text = returned?.textContent.trim();
      if (returned?.dataset.state === 'success') {
        show('success', text);
        form.reset();
      } else {
        show('error', text);
        email.focus();
      }
    } catch (err) {
      show('error');
    } finally {
      form.dataset.busy = 'false';
      button.disabled = false;
    }
  }

  init();
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-lhf-footer]')) init();
  });
  document.addEventListener('shopify:block:select', (e) => {
    const group = e.target.closest?.('.lhf-footer-group');
    const toggle = group?.querySelector('.lhf-footer-toggle');
    if (toggle && mq.matches && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
  });
})();
